/**
 * 权限
 */

 import {
  get,
  post,
  put,
  del
} from '@/util/request'

/**
 * 根据Id查询
 * @param {*} Id
 * @returns
 */
export const SelectPermissionById = (Id) => {
  return get('/api/app/Permission?CurrentId=' + Id);
}

/**
 * 新增数据记录
 * @param {*} data
 * @returns
 */
export const AddPermission = (data) => {
  return post('/api/app/Permission', data, {});
}

/**
 * 更新数据记录
 * @param {*} data
 * @returns
 */
export const ModifyPermission = (data) => {
  return put('/api/app/Permission', data, {});
}

/**
 * 分页获取
 * @param {*} data
 * @returns
 */
export const GetDataPermissionList = (data) => {
  return post('/api/app/Permission/list', data, {});
}

/**
 * 删除记录
 * @param {*} id
 * @returns
 */
export const DeletePermission = (id) => {
  return del('/api/app/Permission/' + id, {}, {});
}